import React, {useEffect} from 'react';
import Header from '../component/Header'
import SubBanner from '../component/SubBanner'
import DiscoverMemoryCare from '../component/DiscoverMemoryCare'
import AndThenThereForService from '../component/AndThenThereForService' 
import MemoryCare from '../component/MemoryCare'
import WhatMemoryCare from '../component/WhatMemoryCare'
import MemoryCarePersonalCare from '../component/MemoryCarePersonalCare'
import MemoryCareCommunity from '../component/MemoryCareCommunity'
import Footer from '../component/Footer'
import '../scss/service.scss'
import '../scss/sub-banner.scss'
import PersonalCare from '../component/PersonalCare';
import ServicePageBg from '../component/ServicePageBg';
import HowMuchDoesCost from '../component/HowMuchDoesCost';

import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchServiceDetails,
} from "../features/service/serviceActions";
import { Helmet } from "react-helmet-async";


function ServicePage() {

    // Get the slug from the URL
    const { slug } = useParams();

    const dispatch = useDispatch();
    const { serviceDetails } = useSelector((state) => state.service);

    useEffect(() => {
      dispatch(fetchServiceDetails(slug));
    }, [dispatch, slug]);

  return (
    <>
      <Helmet>
        <title>{serviceDetails?.meta_title}</title>
        <meta name="description" content={serviceDetails?.meta_description} />
        <meta name="keywords" content={serviceDetails?.meta_keywords} />
      </Helmet>

      <main className='main service-page'>
        <Header />    
        <SubBanner HeaderTitle={serviceDetails?.title} />     
        <DiscoverMemoryCare data={serviceDetails?.page_content?.section_1 || null} />  
        <MemoryCarePersonalCare data={serviceDetails?.page_content?.section_2 || null} />
        <MemoryCare data={serviceDetails?.page_content?.section_3 || null} />
        <ServicePageBg data={serviceDetails?.page_content?.section_4 || null} />
        <PersonalCare data={serviceDetails?.page_content?.section_4 || null} />
        <HowMuchDoesCost data={serviceDetails?.page_content?.section_5 || null}/> 
        <AndThenThereForService data={serviceDetails?.page_content?.section_6 || null} />
        <MemoryCareCommunity data={serviceDetails?.page_content?.section_7 || null} />    
        <WhatMemoryCare data={serviceDetails?.page_content?.section_8 || null} /> 
      </main>
      <Footer />
    </>
  )
}
export default ServicePage 


